'use client';

import { ReactNode, Suspense } from 'react';

import { useCompleteRegistrationGuard } from '@/app/(main)/_hooks/use-complete-registration-guard.hook';

function CompleteRegistrationRedirect() {
  useCompleteRegistrationGuard();

  return null;
}

export function CompleteRegistrationGuard({ children }: { children: ReactNode }) {
  return (
    <>
      <Suspense fallback={null}>
        <CompleteRegistrationRedirect />
      </Suspense>
      {children}
    </>
  );
}
